export enum LUCKYDRAW_OPEN_MODE {
  INSTANT = 'instant', // 1. 즉시 오픈 (기존)
  USE_ITEM = 'useItem', // 2. 랜덤박스 아이템 → 사용 시 오픈
  POST_UPLOAD = 'postUpload', // 3. 게시글 업로드 시 오픈
}

export type LUCKYDRAW_OPEN_MODE_VALUE = typeof LUCKYDRAW_OPEN_MODE[keyof typeof LUCKYDRAW_OPEN_MODE];

export type LUCKYDRAW_REWARD_TYPE = 'item' | 'skill';

export interface ILuckyDrawRewardChance {
  id: string;
  type: LUCKYDRAW_REWARD_TYPE;
  chance: number;
}

export interface IluckydrawItem {
  id?: string;
  title: string;
  contents?: string;
  imgURL?: string;
  itemImgURL?: string; // 뽑기용 아이템 (박스 이미지)
  randomBoxImgURL?: string; // 랜덤박스 아이템 이미지 (USE_ITEM 모드용)
  itemList?: string[];
  skillList?: string[];
  rewardChanceList?: ILuckyDrawRewardChance[];
  buttonText?: string;
  materialItemID?: string | null;
  price?: number;
  /** 결과 일반 아이템 1개 판매 시 실제 지급액. null/undefined면 기존 판매 계산 사용 */
  rewardResellPrice?: number | null;
  order?: number;
  materialCount?: number;
  isShow?: boolean;
  linkto?: string;
  openMode?: LUCKYDRAW_OPEN_MODE_VALUE; // 오픈 모드
}
